// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-pagination {
  font-family: var(--font-family-base);
  list-style-type: none;
  padding-bottom: 50px;
  gap: 8px;
  grid-gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  color: var(--primary-foreground);
  font-weight: 500;
  text-align: center;
}

.rc-pagination-total-text {
  position: absolute;
  bottom: 10px;
  margin: 0;
  left: 0px;
  right: 0px;
  color: var(--primary-foreground);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.rc-pagination-item,
.rc-pagination-prev,
.rc-pagination-next {
  background-color: var(--background-quaternary);
  min-width: 28px;
  height: 28px;
  border: 1px solid var(--primary-border);
}

.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next,
.rc-pagination-item,
.rc-pagination-next {
  margin-right: 0;
  font-family: var(--font-family-base);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: none;
}

.rc-pagination-item a,
.rc-pagination-prev span,
.rc-pagination-next span,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
  color: var(--primary-foreground) !important;
}

.rc-pagination-item:hover,
.rc-pagination-item:focus {
  border-color: var(--primary-bg);
  background-color: var(--primary-bg);
}

.rc-pagination-item:hover a,
.rc-pagination-item:focus a {
  color: var(--common-primary-white-foreground) !important;
}

.rc-pagination-item-active,
.rc-pagination-item-active:hover,
.rc-pagination-item-active:focus {
  border-color: var(--primary-bg);
  background-color: var(--primary-bg);
}

.rc-pagination-item-active a,
.rc-pagination-item-active:hover a,
.rc-pagination-item-active:focus a {
  color: var(--common-primary-white-foreground) !important;
}

.rc-pagination-prev span,
.rc-pagination-next span {
  position: relative;
  top: -1px;
}

.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,
.rc-pagination-jump-next .rc-pagination-jump-custom-icon {
  font-size: 12px;
}

.rc-pagination-jump-afterHover-icon {
  display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {
  display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {
  display: inline-block;
  color: var(--primary-link-foreground);
}

/* rtl */
.rtl .rc-pagination-prev span svg,
.rtl .rc-pagination-next span svg {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/styles/pagination.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,8CAA8C;EAC9C,eAAe;EACf,YAAY;EACZ,uCAAuC;AACzC;;AAEA;;;;;EAKE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;EAKE,2CAA2C;AAC7C;;AAEA;;EAEE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;;;EAGE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;;EAGE,wDAAwD;AAC1D;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,QAAQ;AACR;;EAEE,yBAAyB;AAC3B","sourcesContent":[".rc-pagination {\n  font-family: var(--font-family-base);\n  list-style-type: none;\n  padding-bottom: 50px;\n  gap: 8px;\n  grid-gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n  color: var(--primary-foreground);\n  font-weight: 500;\n  text-align: center;\n}\n\n.rc-pagination-total-text {\n  position: absolute;\n  bottom: 10px;\n  margin: 0;\n  left: 0px;\n  right: 0px;\n  color: var(--primary-foreground);\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.rc-pagination-item,\n.rc-pagination-prev,\n.rc-pagination-next {\n  background-color: var(--background-quaternary);\n  min-width: 28px;\n  height: 28px;\n  border: 1px solid var(--primary-border);\n}\n\n.rc-pagination-prev,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next,\n.rc-pagination-item,\n.rc-pagination-next {\n  margin-right: 0;\n  font-family: var(--font-family-base);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: none;\n}\n\n.rc-pagination-item a,\n.rc-pagination-prev span,\n.rc-pagination-next span,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next {\n  color: var(--primary-foreground) !important;\n}\n\n.rc-pagination-item:hover,\n.rc-pagination-item:focus {\n  border-color: var(--primary-bg);\n  background-color: var(--primary-bg);\n}\n\n.rc-pagination-item:hover a,\n.rc-pagination-item:focus a {\n  color: var(--common-primary-white-foreground) !important;\n}\n\n.rc-pagination-item-active,\n.rc-pagination-item-active:hover,\n.rc-pagination-item-active:focus {\n  border-color: var(--primary-bg);\n  background-color: var(--primary-bg);\n}\n\n.rc-pagination-item-active a,\n.rc-pagination-item-active:hover a,\n.rc-pagination-item-active:focus a {\n  color: var(--common-primary-white-foreground) !important;\n}\n\n.rc-pagination-prev span,\n.rc-pagination-next span {\n  position: relative;\n  top: -1px;\n}\n\n.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,\n.rc-pagination-jump-next .rc-pagination-jump-custom-icon {\n  font-size: 12px;\n}\n\n.rc-pagination-jump-afterHover-icon {\n  display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {\n  display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {\n  display: inline-block;\n  color: var(--primary-link-foreground);\n}\n\n/* rtl */\n.rtl .rc-pagination-prev span svg,\n.rtl .rc-pagination-next span svg {\n  transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
